import 'client-only';

import COOKIE_KEYS from '@/consts/cookieKeys';
import cookies from '@/utils/cookies/client';

export const captureReferrer = (): void => {
  if (!cookies.has(COOKIE_KEYS.landingUrl)) {
    // take first 1000 characters to limit cookie overflow
    const landingPageUrl = window.location.href.substring(0, 1001);
    cookies.set(COOKIE_KEYS.landingUrl, landingPageUrl);
  }

  if (!cookies.has(COOKIE_KEYS.referrerUrl)) {
    // take first 1000 characters to limit cookie overflow
    const referrerUrl = document.referrer.substring(0, 1001);
    cookies.set(COOKIE_KEYS.referrerUrl, referrerUrl);
  }
};
